import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SearchBox = ({ searchText, setSearchNameFunction, history, searchBoxFunction, searchFunctionClick, closeSearchModalFunction, setShowSearchBox }) => {
    const { t } = useTranslation(['search', 'routes']);
    const [debouncedValue, setDebouncedValue] = useState(searchText);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchText.trim() !== '') {
                setDebouncedValue(searchText);
            }
        }, 500); // 500ms debounce delay

        return () => clearTimeout(handler);
    }, [searchText]);

    useEffect(() => {
        if (debouncedValue.trim() !== '') {
            searchBoxFunction(debouncedValue.length, debouncedValue);
        }
    }, [debouncedValue, searchBoxFunction]);

    const onSubmit = (e) => {
        e.preventDefault();
        history.push(`/${t('routes:pretraga')}?q=${searchText.toLowerCase()}`);
        setSearchNameFunction('');
        setShowSearchBox(false);
        closeSearchModalFunction();
    };

    return (
        <form className="form" onSubmit={onSubmit}>
            <div className="search-box">
                <input
                    type="text"
                    id="search-input"
                    className="form-control"
                    placeholder={t('placeholder1')}
                    autoComplete="off"
                    onChange={(e) => setSearchNameFunction(e.target.value)}
                    onClick={searchFunctionClick}
                    value={searchText}
                />
                <span className="search-icon">
                    {searchText === '' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#111">
                            <path d="M507.312 484.688L365.85 343.227C397.041 306.848 416 259.676 416 208C416 93.125 322.875 0 208 0S0 93.125 0 208S93.125 416 208 416C259.676 416 306.848 397.039 343.225 365.852L484.687 507.312C487.812 510.438 491.906 512 496 512S504.188 510.438 507.312 507.312C513.562 501.062 513.562 490.938 507.312 484.688ZM208 384C110.953 384 32 305.047 32 208S110.953 32 208 32S384 110.953 384 208S305.047 384 208 384Z" />
                        </svg>
                    ) : (
                        <i className="fas fa-times clear-search-box" onClick={(e) => { e.stopPropagation(); setSearchNameFunction(''); }}></i>
                    )}
                </span>
            </div>
        </form>
    );
};

export default SearchBox;
